(function () {
  'use strict';

  angular.module('app').service('TransportationModalService', TransportationModalService);

  TransportationModalService.$inject = ['ModalService'];

  function TransportationModalService(ModalService) {
    var service = {
      openTransportationListModal: openTransportationListModal,
    };

    return service;

    ////////////////

    // --------------------------- openTransportationListModal -------------------------

    function openTransportationListModal(websiteId) {
      ModalService.showModal({
        templateUrl: './app/ajs/transportation/modals/transportation-list-modal.html',
        controller: TransportationListsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          websiteId: websiteId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      TransportationListsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'TransportationService',
        'websiteId',
      ];
    }

    function TransportationListsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      TransportationService,
      websiteId
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_transportation_accountadmin'),
        canCreate: AbilityService.can('create_transportation_accountadmin'),
        canUpdate: AbilityService.can('update_transportation_accountadmin'),
        canDestroy: AbilityService.can('destroy_transportation_accountadmin'),
      };

      vm.modalTitle = 'TRANSPORTATION';

      // Methods
      vm.showTransportation = showTransportation;
      vm.addContent = addContent;

      // Initializers
      getTransportations();

      function getTransportations() {
        vm.loadingItems = true;
        var params = {
          get: 'active',
          only: 'basic',
          usage: true,
          website_id: websiteId,
        };

        TransportationService.getTransportations(params).then(function (data) {
          vm.transportations = data.items;
          vm.loadingItems = false;
        });
      }

      function showTransportation(transportation) {
        if (!vm.permissions.canShow) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/transportation/${transportation.id}`);
        }, 200);
      }

      function addContent(transportation) {
        if (!vm.permissions.canCreate) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location
            .path(`/transportation_contents/new`)
            .search({ WSID: websiteId, transportationId: transportation.id });
        }, 200);
      }
    }
  }
})();
